// extracted by mini-css-extract-plugin
module.exports = {"infos":"contact_infos__3V7yn","infoItem":"contact_infoItem__2Rdr0","texts":"contact_texts__1z-9N","label":"contact_label__3nS5Z","info":"contact_info__2nIE1"};